import { addProp } from "@pnp/odata";
import { _Web } from "../webs/types.js";
import { ContentTypes } from "./types.js";
addProp(_Web, "contentTypes", ContentTypes);
//# sourceMappingURL=web.js.map